import { makeStyles } from '@material-ui/core';
import theme from '../../theme/booking-theme';

const headerStyles = makeStyles({
  root: {
    alignItems: 'center',
    background: theme.palette.blue1,
    display: 'flex',
    flexDirection: 'row',
    zIndex: '13',
    minHeight: '64px',

    left: '50% !important',
    transform: 'translateX(-50%)',

    '& .MuiGrid-container': {
      maxWidth: 1440,
      padding: '0px 20px',
      margin: '0 auto',

      [theme.breakpoints.up('md')]: {
        padding: '0 50px',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '0 35px',
      },

      [theme.breakpoints.up('xl')]: {
        padding: '0 50px',
      },

      [theme.breakpoints.up('1441')]: {
        padding: 0,
      },
    },
    '.panel-open &': {
      '& .panel-toggler': {
        '&__icon': {
          transform: 'rotate(180deg)',
        },

        '& .back__label': {
          '&:hover': {
            cursor: 'pointer',
          },
          [theme.breakpoints.up('lg')]: {
            display: 'none',
          },
        },
        [theme.breakpoints.up('lg')]: {
          display: 'none',
        },
      },

      [theme.breakpoints.down('md')]: {
        '& .panel-toggler': {
          justifyContent: 'flex-start',
          fontFamily: theme.typography.proxima.semiBold,

          '& .back__label': {
            ...theme.rccl.labelSmall,
            color: theme.palette.white,
            display: 'flex',
            paddingLeft: '12px',
            fontSize: theme.typography.pxToRem(16),
            fontFamily: 'inherit',
          },

          '&__label': {
            display: 'none',
          },
        },
        '& .share': {
          opacity: '0',
        },
        '& .logo': {
          maxWidth: '0',
          opacity: '0',
        },
      },
    },
    '& .panel-toggler': {
      justifyContent: 'flex-start',
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      marginLeft: 10,

      [theme.breakpoints.up('md')]: {
        marginLeft: '-10px',
      },

      '& h4': {
        fontSize: theme.typography.pxToRem(14),
        fontFamily: theme.typography.proxima.semiBold,
        textTransform: 'capitalize',
        [theme.breakpoints.up('md')]: {
          fontSize: theme.typography.pxToRem(16),
        },
      },

      '&:hover': {
        cursor: 'pointer',
      },

      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },

      '&__icon': {
        marginLeft: '10px',
        transform: 'rotate(0deg)',
        transition: 'transform 0.5s',
        fill: 'white',
      },

      '&__label': {
        color: theme.palette.white,
        lineHeight: theme.typography.pxToRem(18),
        fontSize: theme.typography.pxToRem(16),
        fontFamily: theme.typography.proxima.semiBold,
        letterSpacing: 'unset',
        textTransform: 'lowercase',

        [theme.breakpoints.only('xs')]: {
          maxWidth: '164px',
          textAlign: 'center',
        },
      },
      '&__label:first-letter': {
        textTransform: 'uppercase',
      },
    },

    '& .logo': {
      alignItems: 'center',
      display: 'flex',
      opacity: '1',
      transition: 'opacity, max-width .25s',
      '& a': {
        display: 'flex',
      },

      '&__icon': {
        fill: theme.palette.white,
        height: '24px',
        width: '24px',
      },
    },

    '& .exit-icon': {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    '& .exit-label': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    '& .logout': {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'flex-end',
      fontSize: '16px',
      fontFamily: theme.typography.proxima.semiBold,
      '& button': {
        padding: 0,
        color: 'white',
        textTransform: 'unset',
        fontFamily: 'inherit !important',
        justifyContent: 'flex-end',
        fontSize: `${theme.typography.pxToRem(14)} !important`,
        minWidth: '20px',
        [theme.breakpoints.down('sm')]: {
          minWidth: 25,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: `${theme.typography.pxToRem(16)} !important`,
        },
      },
      '& button:first-letter': {
        textTransform: 'uppercase',
      },
      '& .blankSpaceSpan': {
        padding: '0 2px',
        [theme.breakpoints.up('md')]: {
          padding: '0 6px',
        },
      },
      '& .greetingLink': {
        color: theme.palette.white,
        textDecoration: 'none',
      },
      '& .greetingHeader': {
        textTransform: 'capitalize',
        fontFamily: theme.typography.proxima.semiBold,
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.up('md')]: {
          fontSize: theme.typography.pxToRem(16),
        },
      },
    },

    '& .share': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      opacity: '1',
      transition: 'opacity .25s',

      '&__icon': {
        fill: theme.palette.white,
        marginRight: '8px',

        [theme.breakpoints.down('md')]: {
          height: '20px',
          width: '20px',

          [theme.breakpoints.only('xs')]: {
            height: '22px',
            margin: 0,
            width: '22px',
          },
        },
      },

      '&__label': {
        ...theme.rccl.labelSmall,
        color: theme.palette.white,
        height: 'fit-content',
        textTransform: 'uppercase',

        [theme.breakpoints.only('xs')]: {
          display: 'none',
        },
      },
    },
  },
  backToReservationLink: {
    color: theme.palette.white,
    textDecoration: 'none',
    display: 'flex',
    '& p': {
      fontSize: theme.typography.pxToRem(14),
      fontFamily: theme.typography.proxima.semiBold,
      alignSelf: 'center',
    },
    '& div': {
      margin: '0px 8px 0px 10px',
      [theme.breakpoints.up('md')]: {
        margin: '0px 8px 0px 40px',
      },
    },
  },
});

export default headerStyles;
